module.exports = __webpack_public_path__ + "static/madea_marca_comunicación-71fee54c8a6ee7bdacf20c2a60057a4a.pdf";